module.exports = __webpack_public_path__ + "img/detail-3.c5136d8f.jpg";